export default __webpack_public_path__ + "static/media/profileimage.ef20e673.png";